<script lang="ts">
    import type {LabeledReference, UUID} from 'src/typings';
    import {ignoreUnusedProperties} from 'shared/utils/custom-utils';

    export let value: LabeledReference<UUID>;

    ignoreUnusedProperties(value);
</script>

<span class="empty-component"></span>